<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Registro Módulo
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="close(true)">Nuevo</v-btn>
            <modalComponent :open="obModal.open" :listGeneral="listGeneral" :parametros="parametros" :obModal="obModal" />
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-autocomplete label="Estado *" color="textbox" :items="listGeneral.listEstado"
                        item-text="nombre_estado" item-value="id_estado" v-model='obSearch.idEstado' outlined dense />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" v-model="obSearch.search" color="textbox" clearable dense prepend-inner-icon="search" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera" :items="listGeneral.detalle"
                        class="elevation-3">

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="editItem(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'ModuloView',
        components: {
            modalComponent: () => import('@/components/seguridad/ModalModuloComponent.vue')
        },
        data: () => ({
            obSearch:{
                search:'',
                idEstado:null
            },
            obModal: {
                open: false,
                titulo: ''
            },
            listGeneral: {},
            parametros: {},
            disabled:false
        }),
        created() {
            var error = 'E';
            this.disabled = true;
            axios.post(`${BASE_URI}administrador/modulo/carga-general`)
                .then((r) => {
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                            this.$set(this, 'listGeneral', r.data.data.listas);
                            this.$set(this, 'parametros', r.data.data.parametros);
                            this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                            this.disabled = false;
                            this.onListar('L');
                })
                .catch((e) => {
                        this.disabled = false;
                        mensajesAlerta(e, error);
                })
        },
        methods: {
            onListar(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    this.disabled = true;
                    this.listGeneral.detalle = [];
                    axios.post(`${BASE_URI}administrador/modulo/listar`,{opcion:'LISTAR',idEstado:this.obSearch.idEstado})
                        .then((r) => {
                                if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                    this.listGeneral.detalle = r.data.data;
                                    this.disabled = false;
                        })
                        .catch((e) => {
                                this.disabled = false;
                                mensajesAlerta(e, error);
                        })
                }
            },
            close(band){
                this.obModal = {
                    open: band,
                    titulo: 'Nuevo Módulo',
                    idEstado: _.toString(this.parametros.id_estado_default)
                }
            },
            editItem(v){
                this.obModal = _.merge({},this.obModal,v,{titulo:'Editar Módulo',open:true});
            },
            submit(){
                var error = 'E';
                var keys = ['open','titulo','opcion','estado'];
                var o = _.merge({opcion:_.size(this.obModal.idModulo) == 0 ? 'I' : 'U'},_.omit(this.obModal,keys));

                axios.post(`${BASE_URI}administrador/modulo/inserta-actualiza`,o)
                        .then((r)=>{
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) {  error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) }
                                    mensajeAlertaTiempo(r.data.mensaje,'S');
                                    this.disabled = false;
                                    this.close(false);
                                    this.onListar('L');
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                            this.disabled = false;
                        });
            }
        },
        provide(){
            return{
                close:this.close,
                submit:this.submit
            }
        }
    }
</script>